import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IFilterResponse } from 'src/app/core/interfaces/filter-response.interface';
import { IMediaFile } from 'src/app/core/interfaces/media-file.interface';

import { IQuotation } from 'src/app/core/interfaces/quotation.interface';
import { ISentToPartner } from 'src/app/core/interfaces/sent-to-partner.interface';
import { BaseResponse } from 'src/app/core/models/base-response.model';
import { HttpService } from 'src/app/core/services/http.service';

@Injectable({
  providedIn: 'root',
})
export class QuotationsService {
  private readonly http = inject<HttpService>(HttpService);
  private readonly endpoint = 'quotations';

  queryQuotation(id: string): Observable<BaseResponse<IQuotation>> {
    return this.http.get<IQuotation>(`${this.endpoint}/${id}`);
  }

  queryQuotations(queryParams: string): Observable<BaseResponse<IFilterResponse<IQuotation>>> {
    return this.http.get<IFilterResponse<IQuotation>>(`${this.endpoint}?${queryParams}`);
  }

  create(quotation: Partial<IQuotation>): Observable<BaseResponse<any>> {
    return this.http.post<any>(this.endpoint, quotation);
  }

  update(quotation: Partial<IQuotation>): Observable<BaseResponse<any>> {
    return this.http.put<any>(`${this.endpoint}/${quotation.id}`, quotation);
  }

  delete(id: string): Observable<BaseResponse<any>> {
    return this.http.delete<any>(`${this.endpoint}/${id}`);
  }

  copy(id: string): Observable<BaseResponse<string>> {
    return this.http.post<string>(`${this.endpoint}/${id}/copy`, {});
  }

  markAsFavorite(quotationId: string): Observable<BaseResponse<any>> {
    return this.http.put<any>(`${this.endpoint}/${quotationId}/favorite`, {
      id: quotationId,
    });
  }

  smartBanner(quotationId: string): Observable<BaseResponse<any>> {
    return this.http.put<any>(`${this.endpoint}/${quotationId}/smartbanner`, {
      id: quotationId,
    });
  }

  sentToPartner(data: ISentToPartner) {
    return this.http.post<any>(`${this.endpoint}/${data.id}/send-to-partner`, data);
  }

  download(id: string): Observable<BaseResponse<IMediaFile>> {
    return this.http.get<IMediaFile>(`${this.endpoint}/${id}/download`);
  }
}
